// Goons buy panel. One row per goon type — owned count, current price, buy
// button. Reads price from goonManager, dispatches buy via the bus.

import { Events, on, emit } from './eventBus.js'
import { GoonConfig, GoonTypes } from '../config/balance.js'
import { priceOf, isAtCap } from '../game/goonManager.js'
import { getWealth } from '../game/seasonManager.js'
import { formatCoins } from './format.js'

export function mountGoonsPanel({ root }) {
  const buyableIds = Object.values(GoonTypes).filter((id) => GoonConfig[id].buyable)
  root.innerHTML = buyableIds.map(rowTemplate).join('')

  const rows = new Map() // goonId → { ownedEl, priceEl, buyEl }
  for (const id of buyableIds) {
    const row = root.querySelector(`[data-goon="${id}"]`)
    rows.set(id, {
      ownedEl: row.querySelector('[data-owned]'),
      priceEl: row.querySelector('[data-price]'),
      buyEl: row.querySelector('[data-buy]'),
    })
    row.querySelector('[data-buy]').addEventListener('click', () => {
      emit(Events.GoonBuyRequested, { goonId: id })
    })
  }

  const refresh = () => {
    const wealth = getWealth()
    for (const [id, els] of rows) {
      const atCap = isAtCap(id)
      const price = priceOf(id)
      els.priceEl.textContent = atCap ? 'MAX' : formatCoins(price)
      els.buyEl.disabled = atCap || wealth < price
    }
  }
  on(Events.KingdomChange, refresh)

  on(Events.WealthChange, refresh)
  on(Events.GoonOwnedChange, ({ goonId, owned }) => {
    const els = rows.get(goonId)
    if (!els) return // Noble cats aren't in this panel; broadcast still fires.
    els.ownedEl.textContent = String(owned)
    refresh()
  })

  refresh()
}

function rowTemplate(id) {
  const cfg = GoonConfig[id]
  return `
    <div class="hud__goon-row" data-goon="${id}">
      <div class="hud__goon-info">
        <div class="hud__goon-name">${cfg.name}</div>
        <div class="hud__goon-desc">${cfg.clicksPerSec} clk/s</div>
      </div>
      <div class="hud__goon-owned" data-owned>0</div>
      <button class="hud__goon-buy" data-buy>
        <span class="lbl">BUY</span>
        <span class="price" data-price>0m</span>
      </button>
    </div>
  `
}
